<template>
    <div
        class="rp-messenger-order-item" 
        >
        <MediaTypeOrder
          :message="parsedOrder"
          :cardType="'listing'"
          :showTopHeaderOnly="showTopHeaderOnly"
          @click="handleAction('onOrderClick', orderData)"
          :showViewButton="showViewButton"
        />
        <div class="rp-messenger-order-buttons" v-if="actionsList && actionsList.length">
          <Inline>
            <!-- <reorderButton
                    :label="$t('orderList.reorder')"
                    class="small"
                    @click="$emit('onNewConversationButtonClick')"
            />
            <HMargin :unit="0.5"/> -->
            <template 
                v-for="action of actionsList"
            >
                <reorderButton
                    :key="action.buttonLabel+'order-action'"
                    :label="$t(`orderList.${action.buttonLabel}`)"
                    class="small"
                    @click="handleAction(action.actionName, orderData)"
                />
            </template>
           
          </Inline>
        </div>
      </div>
</template>
<script>
import { getTheFormattedOrderData } from '../../../constants'
import reorderButton from "./reorderButton";
const defaultActions = [{
    buttonLabel: 'view',
    actionName: 'onOrderClick'
},
{
    buttonLabel: 'track',
    actionName: 'onOrderTrackUrlClick',
}
]
export default {
    props: {
        orderData: {
            type: Object,
            required: true,
        },
        showTopHeaderOnly: {
            type: Boolean,
            default: false,
        },
        actionsList: {
            type: Array,
            default: () => defaultActions,
        },
        showViewButton: {
            type: Boolean,
            default: false
        }
    },

    components: {
        reorderButton
    },

    computed: {
        parsedOrder() {
            return { mediaValue: JSON.stringify(getTheFormattedOrderData({ orderInfo: this.orderData })) }
        }
    },

    methods: {
        handleAction(actionName, payload) {
            this.$emit('action', { actionName,  payload })
        }
    }
}
</script>
<style lang="scss" scoped>
.rp-messenger-order-item {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 20px;
    @include for-size(tablet-landscape-up) {
		padding: 20px 40px;
	}
	@include for-size(desktop-up) {
		padding: $desktopPadding;
	}
    .rp-messenger-order-buttons {
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
      width: 100%;
      margin-top: 1rem;
      cursor: initial;
    }
}
</style>